<button
  data-test="add-customer-button"
  class="btn btn-secondary"
  type="button"
  (click)="openModalInvite()"
>
  {{ 'button_labels.add_customer' | translate }}
</button>